import { Alert, DrawerBody, DrawerTitle, Subhead, useRebrand } from '@growtherapy/sprout-ui';

import './index.css';

import { DrawerHeader } from '../../components/DrawerHeader';
import { ConnectionError } from '../../session';
import { RETRYING_CONNECTION_INFO_TEXT, TERMINAL_CONNECTION_ERROR_TEXT } from '../sync';
import { ClientQueueWrapper as ClientQueue } from './ClientQueueWrapper';
import { ClientsInSessionWrapper as ClientsInSession } from './ClientsInSessionWrapper';

type ClientsDrawerProps = {
  clientQueueComponent: typeof ClientQueue;
  clientsInSessionComponent: typeof ClientsInSession;
  connectionError?: ConnectionError | null;
};

export function ClientsDrawer({
  clientQueueComponent: ClientQueueComponent,
  clientsInSessionComponent: ClientsInSessionComponent,
  connectionError,
}: ClientsDrawerProps) {
  const isRebrand = useRebrand();
  return (
    <>
      <DrawerHeader data-testid='waiting-room.header'>
        {isRebrand && (
          <Subhead.Small as='h2' className='rebrand:text-text-inverse'>
            Clients
          </Subhead.Small>
        )}
        {!isRebrand && <DrawerTitle>Clients</DrawerTitle>}
      </DrawerHeader>
      <DrawerBody className='flex flex-col gap-y-4' data-testid='waiting-room.body'>
        {connectionError ? (
          <Alert
            heading={connectionError.terminal ? TERMINAL_CONNECTION_ERROR_TEXT : RETRYING_CONNECTION_INFO_TEXT}
            use={connectionError.terminal ? 'error' : 'info'}
            headingAs='h3'
          />
        ) : (
          <>
            <ClientQueueComponent />
            <div className='my-4 border-b border-neutral-300 rebrand:border-border-default' />
            <ClientsInSessionComponent />
          </>
        )}
      </DrawerBody>
    </>
  );
}
